import React, { createContext } from 'react'
import { FetchContextType } from '@purecarslabs/signal-core/contextFetch/types'
import { createFetchContextProps } from '@purecarslabs/signal-core/contextFetch/FetchContext'
import createContextFetchLoader from '@purecarslabs/signal-core/contextFetch/Loader'
import { useLeadFormSpec, UseLeadFormSpecType } from './fetchHooks'
import { LeadFormSpecResponseType } from './types'

export function createLeadFormSpecDataContext(): React.Context<
  FetchContextType<LeadFormSpecResponseType>
> {
  return createContext(createFetchContextProps<LeadFormSpecResponseType>())
}

export const LeadFormSpecContext = createLeadFormSpecDataContext()

// this is the actual lead form spec fetcher, which will fetch all accounts using the useLeadFormSpec hook and then
// store the result in the LeadFormSpecContext.
export const LeadFormSpecFetcher = createContextFetchLoader<
  LeadFormSpecResponseType,
  UseLeadFormSpecType
>({
  fetchHook: useLeadFormSpec,
  FetchContext: LeadFormSpecContext
})
